(function () {
  'use strict';

  var CFG = window.MAGIC_CONFIG || {};
  var DRAWER_CFG = window.GK_CART_DRAWER || {};

  /* ── Utilities ─────────────────────────────────────────────── */

  function formatMoney(cents) {
    var amount = Math.round(Number(cents) || 0);
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(amount, DRAWER_CFG.moneyFormat || '${{amount}}');
    }
    return '\u20B9' + Math.floor(amount / 100);
  }

  function formatMoneyFromRupees(rupees) {
    return formatMoney(Math.round(Number(rupees) || 0) * 100);
  }

  function esc(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  var _mutationQueue = Promise.resolve();
  var _mutationPending = 0;

  function cartMutate(url, opts) {
    _mutationPending++;
    function settle() {
      _mutationPending--;
      if (_mutationPending === 0 && _refreshPending) {
        _refreshPending = false;
        scheduleRefresh(150);
      }
    }
    var p = _mutationQueue.then(function () {
      var nativeFetch = window._gkNativeFetch || window.fetch;
      return nativeFetch(url, Object.assign({ headers: { 'Content-Type': 'application/json' } }, opts))
        .then(function (r) { return r.json(); });
    }).then(function (data) {
      settle();
      return data;
    });
    _mutationQueue = p.catch(function () { settle(); });
    return p;
  }

  function cartFetch(url, opts) {
    var isMutation = url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/add') !== -1 ||
                     url.indexOf('/cart/update') !== -1 || url.indexOf('/cart/clear') !== -1;
    if (isMutation) return cartMutate(url, opts);
    var nativeFetch = window._gkNativeFetch || window.fetch;
    return nativeFetch(url, Object.assign({ headers: { 'Content-Type': 'application/json' } }, opts))
      .then(function (r) { return r.json(); });
  }

  function addUnique(list, value) {
    if (value && list.indexOf(value) === -1) list.push(value);
  }

  /* ── Section Refresh Infrastructure ────────────────────────── */

  function getCartSectionIds() {
    var ids = [];
    var cartEl = document.getElementById('xo-cart-mini') || document.querySelector('xo-cart-mini');
    if (cartEl && cartEl.dataset) addUnique(ids, cartEl.dataset.gkSectionId);
    var sectionEl = cartEl && cartEl.closest('[id^="shopify-section-"]');
    if (sectionEl && sectionEl.id) addUnique(ids, sectionEl.id.replace(/^shopify-section-/, ''));
    addUnique(ids, 'cart');
    addUnique(ids, 'xo-cart-mini');
    return ids;
  }

  function getSectionHtml(data, sectionIds) {
    var html = '';
    sectionIds.forEach(function (id) {
      if (!html && data && data[id]) html = data[id];
    });
    if (!html) {
      Object.keys(data || {}).some(function (key) {
        var candidate = data[key];
        if (candidate && candidate.indexOf('xo-cart-mini-content') !== -1) {
          html = candidate;
          return true;
        }
        return false;
      });
    }
    return html;
  }

  function syncDrawerSlot(doc, slotId) {
    var newSlot = doc.getElementById(slotId);
    var oldSlot = document.getElementById(slotId);
    if (newSlot && oldSlot) oldSlot.innerHTML = newSlot.innerHTML;
  }

  /* ── Magic Blocks Placement ────────────────────────────────── */

  var _blocksPlaced = false;

  function placeBlocksFromSource() {
    var source = document.getElementById('gk-magic-blocks-source');
    var topSlot = document.getElementById('gk-top-blocks-slot');
    var botSlot = document.getElementById('gk-bottom-blocks-slot');
    if (!source || (!topSlot && !botSlot)) return false;
    var topIds = ['gk-announcement', 'gk-tiered-rewards', 'gk-scarcity-timer'];
    var botIds = ['gk-savings-bar', 'gk-free-gift-strip', 'gk-one-tick', 'gk-cart-upsell'];

    // Move a block from source → slot. Critical: if the slot ALREADY has
    // an element with this id, we must remove it first. Otherwise we end
    // up with two nodes sharing the same id (one orphaned in source, one
    // in slot), and getElementById/querySelector return the wrong one,
    // causing JS state set on the old node to never apply to the new
    // node the user actually sees (e.g. upsell wrap stuck visible
    // because fillUpsell wrote `hidden` to the orphan in source).
    function moveBlock(id, slot) {
      if (!slot) return;
      var fresh = source.querySelector('#' + id);
      if (!fresh) return;
      var existing = slot.querySelector('#' + id);
      if (existing) {
        // Preserve rendered upsell carousel across section refreshes so
        // themeCartRefresh doesn't reset data-state to "loading" and
        // flash the empty header while JS re-fetches the same products.
        if (id === 'gk-cart-upsell') {
          var oldCarousel = existing.querySelector('#gk-upsell-carousel');
          var newCarousel = fresh.querySelector('#gk-upsell-carousel');
          var oldState = existing.getAttribute('data-state');
          if (oldCarousel && newCarousel && oldCarousel.children.length) {
            newCarousel.innerHTML = oldCarousel.innerHTML;
            if (oldState) fresh.setAttribute('data-state', oldState);
            if (oldState === 'ready') {
              fresh.removeAttribute('hidden');
              var oldLoader = existing.querySelector('#gk-upsell-loading');
              var newLoader = fresh.querySelector('#gk-upsell-loading');
              if (newLoader && oldLoader && oldLoader.style.display === 'none') {
                newLoader.style.display = 'none';
                newLoader.setAttribute('aria-hidden', 'true');
              }
            }
          }
        }
        slot.replaceChild(fresh, existing);
      } else {
        slot.appendChild(fresh);
      }
    }

    topIds.forEach(function (id) { moveBlock(id, topSlot); });
    botIds.forEach(function (id) { moveBlock(id, botSlot); });
    liftAnnouncementAboveContent();
    return true;
  }

  /**
   * Move the announcement out of the scrollable __content area and place it
   * directly before .xo-modal-content-style1__body (between header and body),
   * so it stays visible above the items list.
   *
   * Cart drawer refreshes re-render the source section, which produces a
   * fresh #gk-announcement inside topSlot. To avoid duplicate banners we
   * collect every announcement in the modal, keep the most recent one,
   * remove the rest, then lift the kept one into the correct position.
   */
  function liftAnnouncementAboveContent() {
    var modal = document.querySelector('xo-modal[xo-for-cart-mini], xo-modal[xo-name="cart"]');
    if (!modal) return;
    var modalInner = modal.querySelector('.xo-modal-content-style1__inner');
    if (!modalInner) return;
    var body = modalInner.querySelector('.xo-modal-content-style1__body');
    if (!body) return;

    // Find every announcement-like node inside the modal.
    var nodes = modalInner.querySelectorAll('.gk-announcement, #gk-announcement');
    if (!nodes.length) return;

    // Prefer the freshly rendered one (the one currently inside topSlot /
    // __content), since it carries the latest merchant-edited settings.
    var keep = null;
    for (var i = nodes.length - 1; i >= 0; i--) {
      var n = nodes[i];
      if (n.closest('.xo-modal-content-style1__content')) { keep = n; break; }
    }
    if (!keep) keep = nodes[0];

    // Drop everything else (deduplicates the visible banners).
    nodes.forEach(function (n) { if (n !== keep && n.parentNode) n.parentNode.removeChild(n); });

    keep.classList.add('gk-announcement--lifted');
    if (keep.parentElement !== modalInner || keep.nextElementSibling !== body) {
      modalInner.insertBefore(keep, body);
    }
  }

  function setupMagicBlocks(onReady) {
    var attempts = 0;
    function tryPlace() {
      var topSlot = document.getElementById('gk-top-blocks-slot');
      var botSlot = document.getElementById('gk-bottom-blocks-slot');
      if (!topSlot && !botSlot) {
        attempts++;
        if (attempts < 20) { setTimeout(tryPlace, 50); return; }
        if (onReady) onReady();
        return;
      }
      if (!_blocksPlaced) { _blocksPlaced = true; placeBlocksFromSource(); }
      if (onReady) onReady();
    }
    tryPlace();
  }

  /* ── Accordion State ───────────────────────────────────────── */

  var _accordionOpen = false;

  function saveAccordionState() {
    var body = document.querySelector('.gk-price-accordion-body');
    if (body) _accordionOpen = body.classList.contains('is-open');
  }

  function restoreAccordionState() {
    var body = document.querySelector('.gk-price-accordion-body');
    var icon = document.querySelector('.gk-price-accordion-icon');
    if (!body) return;
    if (_accordionOpen) {
      body.classList.add('is-open');
      body.style.display = 'block';
      if (icon) icon.style.transform = 'rotate(0deg)';
    } else {
      body.classList.remove('is-open');
      body.style.display = 'none';
      if (icon) icon.style.transform = 'rotate(180deg)';
    }
  }

  /* ── Merge Duplicate Variants ─────────────────────────────── */

  function mergeDuplicateVariants(cart, callback) {
    // NOTE: Disabled — this store has a server-side Cart Transform Function
    // that splits line items into multiple entries for the same variant.
    // Attempting to merge them client-side causes a fight loop (and in some
    // cases item loss). Visual deduplication is handled in renderCartDOM instead.
    callback(false);
    return;
    if (!cart || !cart.items || cart.items.length < 2) { callback(false); return; }
    var seen = {};
    var hasDupes = false;
    cart.items.forEach(function (item) {
      var vid = String(item.variant_id);
      var props = item.properties || {};
      if (props._is_free_gift === 'true' || props._is_one_tick === 'true') return;
      if (seen[vid]) { hasDupes = true; } else { seen[vid] = true; }
    });
    if (!hasDupes) { console.log('[merge] no dupes'); callback(false); return; }
    if (_mergeAttempts >= 3) { console.log('[merge] max attempts reached'); callback(false); return; }
    _mergeAttempts++;
    console.log('[merge] attempt #' + _mergeAttempts);
    clearTimeout(_mergeAttemptsResetTimer);
    _mergeAttemptsResetTimer = setTimeout(function () { _mergeAttempts = 0; }, 5000);
    var nativeFetch = window._gkNativeFetch || window.fetch;
    nativeFetch('/cart.js').then(function (r) { return r.json(); })
      .then(function (freshCart) {
        var freshSeen = {};
        var freshDupes = [];
        (freshCart.items || []).forEach(function (item) {
          var vid = String(item.variant_id);
          var props = item.properties || {};
          if (props._is_free_gift === 'true' || props._is_one_tick === 'true') return;
          if (freshSeen[vid]) {
            freshDupes.push({ keep: freshSeen[vid], merge: item });
          } else {
            freshSeen[vid] = item;
          }
        });
        if (!freshDupes.length) { console.log('[merge] fresh has no dupes'); callback(false); return; }
        var updates = {};
        freshDupes.forEach(function (d) {
          updates[d.keep.key] = (updates[d.keep.key] || d.keep.quantity) + d.merge.quantity;
          updates[d.merge.key] = 0;
        });
        console.log('[merge] sending update.js with:', JSON.stringify(updates));
        return cartFetch('/cart/update.js', {
          method: 'POST',
          body: JSON.stringify({ updates: updates })
        }).then(function () { callback(true); });
      })
      .catch(function () { callback(false); });
  }

  /* ── Theme Cart Refresh (atomic) ───────────────────────────── */

  function fetchCartData(root, sectionIds) {
    var nativeFetch = window._gkNativeFetch || window.fetch;
    return Promise.all([
      nativeFetch(root + '?sections=' + encodeURIComponent(sectionIds.join(','))).then(function (r) { return r.json(); }),
      nativeFetch(root + 'cart.js').then(function (r) { return r.json(); })
    ]);
  }

  function applyCartDOM(data, sectionIds) {
    var sectionHtml = getSectionHtml(data, sectionIds);
    if (!sectionHtml) return;
    var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var uids = ['xo-cart-mini-content', 'xo-cart-mini-drawer-footer'];
    uids.forEach(function (uid) {
      var newEl = doc.querySelector('[xo-unique-id="' + uid + '"]');
      var oldEl = document.querySelector('[xo-unique-id="' + uid + '"]');
      if (newEl && oldEl) oldEl.innerHTML = newEl.innerHTML;
    });
    syncDrawerSlot(doc, 'gk-top-blocks-slot');
    var freshSource = doc.getElementById('gk-magic-blocks-source');
    var liveSource = document.getElementById('gk-magic-blocks-source');
    if (freshSource && liveSource) liveSource.innerHTML = freshSource.innerHTML;
    _blocksPlaced = false;
    placeBlocksFromSource();
    restoreAccordionState();
    dedupeCartItemsDisplay();
  }

  // Visual deduplication: server-side Cart Transform Functions may split a single
  // variant into multiple line items. We collapse duplicates into one row showing
  // the combined quantity (computed from the DOM's own per-row dataset.quantity,
  // which always reflects the server state at last render), while keeping the
  // hidden rows in the DOM so cart totals and properties remain accurate.
  function dedupeCartItemsDisplay() {
    var items = document.querySelectorAll('xo-cart-mini .xo-cart-mini-item');
    // Group by variant_id; only real (non-gift, non-one-tick) items participate.
    var groups = {};
    var order = [];
    items.forEach(function (item) {
      var vid = item.dataset.variantId;
      var isGift = item.classList.contains('gk-is-free-item');
      var isOneTick = item.dataset.isOneTick === 'true';
      if (!vid || isGift || isOneTick) {
        item.classList.remove('gk-dedupe-hidden');
        item.removeAttribute('aria-hidden');
        delete item.dataset.dedupedInto;
        return;
      }
      if (!groups[vid]) { groups[vid] = []; order.push(vid); }
      groups[vid].push(item);
    });
    order.forEach(function (vid) {
      var entries = groups[vid];
      var totalQty = 0;
      entries.forEach(function (entry) {
        totalQty += parseInt(entry.dataset.quantity, 10) || 0;
      });
      var keep = entries[0];
      var keepInput = keep.querySelector('.xo-quantity-style2__number, input[name="quantity"]');
      if (keepInput) keepInput.value = totalQty;
      keep.dataset.dedupeTotal = String(totalQty);
      keep.classList.remove('gk-dedupe-hidden');
      keep.removeAttribute('aria-hidden');
      delete keep.dataset.dedupedInto;
      for (var i = 1; i < entries.length; i++) {
        entries[i].classList.add('gk-dedupe-hidden');
        entries[i].setAttribute('aria-hidden', 'true');
        entries[i].dataset.dedupedInto = keep.dataset.lineKey || '';
      }
    });
    syncQtyMinusDisabledState();
  }

  /**
   * Toggle the .gk-qty-disabled class on every minus button based on its
   * own line's effective quantity (post-dedupe). Quantity 1 → disabled.
   * Free-gift/one-tick items remain locked entirely by the legacy logic.
   */
  function syncQtyMinusDisabledState() {
    var items = document.querySelectorAll('xo-cart-mini .xo-cart-mini-item, .xo-modal[xo-name="cart"] .xo-cart-mini-item');
    items.forEach(function (item) {
      var minus = item.querySelector('.gk-cart-minus');
      if (!minus) return;
      var input = item.querySelector('.xo-quantity-style2__number, input[name="quantity"]');
      var qty = input ? parseInt(input.value, 10) : parseInt(item.dataset.quantity, 10);
      if (isNaN(qty) || qty <= 1) {
        minus.classList.add('gk-qty-disabled');
        minus.setAttribute('aria-disabled', 'true');
      } else {
        minus.classList.remove('gk-qty-disabled');
        minus.removeAttribute('aria-disabled');
      }
    });
  }

  function observeCartItemsForDedupe() {
    if (observeCartItemsForDedupe._bound) return;
    observeCartItemsForDedupe._bound = true;

    if (!document.getElementById('gk-dedupe-style')) {
      var style = document.createElement('style');
      style.id = 'gk-dedupe-style';
      style.textContent = '.xo-cart-mini-item.gk-dedupe-hidden{display:none !important;}';
      document.head.appendChild(style);
    }

    var scheduled = false;
    function runDedupe() {
      scheduled = false;
      try { dedupeCartItemsDisplay(); } catch (e) { /* ignore */ }
    }

    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(runDedupe);
    });

    function attach() {
      var root = document.querySelector('xo-cart-mini');
      if (!root) { setTimeout(attach, 500); return; }
      observer.observe(root, { childList: true, subtree: true });
      runDedupe();
    }
    attach();
  }

  function processCart(cart) {
    if (!cart) return false;
    var giftsPending = onCartChange(cart) === true;
    Ann.init();
    Timer.init();
    OneTick.init();
    Checkout.apply();
    GiftImages.load();
    return giftsPending;
  }

  function themeCartRefresh(done) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var sectionIds = getCartSectionIds();

    saveAccordionState();

    fetchCartData(root, sectionIds)
      .then(function (results) {
        try {
          applyCartDOM(results[0], sectionIds);
          var giftsPending = processCart(results[1]);

          if (giftsPending) {
            var giftTimeout = setTimeout(function () {
              if (done) done({ pendingCartOps: false });
              done = null;
            }, 8000);
            _mutationQueue.then(function () {
              return fetchCartData(root, sectionIds);
            }).then(function (freshResults) {
              clearTimeout(giftTimeout);
              try {
                saveAccordionState();
                applyCartDOM(freshResults[0], sectionIds);
                processCart(freshResults[1]);
              } catch (e) { /* ignore */ }
              mergeDuplicateVariants(freshResults[1], function (merged) {
                if (merged) scheduleRefresh(300);
                if (done) done({ pendingCartOps: false });
              });
            }).catch(function () {
              clearTimeout(giftTimeout);
              if (done) done({ pendingCartOps: false });
            });
            return;
          }

          mergeDuplicateVariants(results[1], function (merged) {
            if (merged) scheduleRefresh(300);
            if (done) done({ pendingCartOps: false });
          });
        } catch (e) {
          if (done) done({ pendingCartOps: false });
        }
      })
      .catch(function () {
        if (done) done({ pendingCartOps: false });
      });
  }

  /* ── Schedule Refresh (debounced, single-flight) ───────────── */

  var _refreshTimer = null;
  var _refreshBusy = false;
  var _refreshPending = false;

  function scheduleRefresh(delay) {
    clearTimeout(_refreshTimer);
    if (_refreshBusy || _mutationPending > 0) {
      _refreshPending = true;
      return;
    }
    _refreshTimer = setTimeout(function () {
      if (_refreshBusy || _mutationPending > 0) { _refreshPending = true; return; }
      _refreshBusy = true;
      if (!CartSync.isActive()) CartSync.begin();
      themeCartRefresh(function (result) {
        _refreshBusy = false;
        if (result && result.pendingCartOps) {
          _refreshPending = false;
          return;
        }
        CartSync.finish();
        if (_refreshPending) {
          _refreshPending = false;
          scheduleRefresh(200);
        }
      });
    }, delay || 300);
  }

  /* ── Cart Line Controls ────────────────────────────────────── */

  function closestElement(target, selector) {
    var el = target && target.nodeType === 1 ? target : target && target.parentElement;
    return el && el.closest ? el.closest(selector) : null;
  }

  function getCartLineControlData(control) {
    var item = control && control.closest && control.closest('.xo-cart-mini-item');
    if (!item) return null;
    var input = item.querySelector('.xo-quantity-style2__number, input[name="quantity"]');
    var quantity = parseInt(input ? input.value : item.dataset.quantity, 10);
    if (isNaN(quantity)) quantity = 1;
    return {
      item: item,
      input: input,
      lineKey: item.dataset.lineKey,
      id: item.dataset.lineKey || item.dataset.variantId || item.getAttribute('xo-product-id'),
      quantity: quantity
    };
  }

  function setCartLineBusy(data, isBusy) {
    if (!data || !data.item) return;
    data.item.classList.toggle('is-cart-updating', isBusy);
    data.item.setAttribute('aria-busy', isBusy ? 'true' : 'false');
  }

  var _lineQueue = {};

  // Queue key: prefer line item key (so distinct line items are independent),
  // fall back to variant_id when no line key is available (initial click before refresh).
  function _getLineQueueKey(data) {
    if (data.lineKey) return 'k:' + data.lineKey;
    var vid = data.item && data.item.dataset && data.item.dataset.variantId;
    return vid ? 'v:' + vid : null;
  }

  function updateCartLine(data, quantity) {
    if (!data || !data.item) { scheduleRefresh(50); return; }
    quantity = Math.max(0, quantity);
    if (data.input) data.input.value = quantity;
    if (!data.lineKey) data.lineKey = data.item.dataset.lineKey;
    var queueKey = _getLineQueueKey(data);
    if (!queueKey) { scheduleRefresh(50); return; }

    var existing = _lineQueue[queueKey];
    var wasRunning = existing && existing.running;
    _lineQueue[queueKey] = { qty: quantity, data: data, running: wasRunning };
    if (wasRunning) return;
    _flushLine(queueKey);
  }

  function _flushLine(queueKey) {
    var entry = _lineQueue[queueKey];
    if (!entry) return;
    var data = entry.data;
    entry.running = true;

    setCartLineBusy(data, true);
    if (!CartSync.isActive()) CartSync.begin();

    var sentQty;
    var nativeFetch = window._gkNativeFetch || window.fetch;
    var waitFor = _mutationPending > 0 ? _mutationQueue : Promise.resolve();
    waitFor.catch(function () {}).then(function () {
      return nativeFetch('/cart.js').then(function (r) { return r.json(); });
    })
      .then(function (cart) {
        var variantId = data.item.dataset.variantId;
        // Find all real (non-gift, non-one-tick) entries for this variant.
        var entries = (cart.items || []).filter(function (item) {
          if (String(item.variant_id) !== variantId) return false;
          var p = item.properties || {};
          return p._is_free_gift !== 'true' && p._is_one_tick !== 'true';
        });
        if (!entries.length) throw new Error('not_found');
        sentQty = _lineQueue[queueKey] ? _lineQueue[queueKey].qty : entry.qty;

        // Single line: use change.js (preserves any line item properties).
        if (entries.length === 1) {
          return cartFetch('/cart/change.js', {
            method: 'POST',
            body: JSON.stringify({ id: entries[0].key, quantity: sentQty })
          });
        }
        // Multi-line (Cart Transform split): set total on the line item the user
        // clicked (if it still exists) and zero the rest.
        var keepKey = entries[0].key;
        if (data.lineKey) {
          for (var k = 0; k < entries.length; k++) {
            if (entries[k].key === data.lineKey) { keepKey = data.lineKey; break; }
          }
        }
        var updates = {};
        entries.forEach(function (item) {
          updates[item.key] = item.key === keepKey ? sentQty : 0;
        });
        return cartFetch('/cart/update.js', {
          method: 'POST',
          body: JSON.stringify({ updates: updates })
        });
      })
      .then(function () {
        var latest = _lineQueue[queueKey];
        if (latest && latest.qty !== sentQty) {
          latest.running = false;
          _flushLine(queueKey);
        } else {
          delete _lineQueue[queueKey];
          scheduleRefresh(300);
        }
      })
      .catch(function () {
        delete _lineQueue[queueKey];
        setCartLineBusy(data, false);
        CartSync.finish();
        scheduleRefresh(300);
      });
  }

  function bindCartControlFallbacks() {
    if (bindCartControlFallbacks._bound) return;
    bindCartControlFallbacks._bound = true;

    document.addEventListener('click', function (event) {
      var remove = closestElement(event.target, '.gk-cart-remove');
      var minus = closestElement(event.target, '.gk-cart-minus');
      var plus = closestElement(event.target, '.gk-cart-plus');
      if (!remove && !minus && !plus) return;
      var data = getCartLineControlData(remove || minus || plus);
      if (!data) return;
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      if (remove) {
        var itemEl = closestElement(remove, '.xo-cart-mini-item');
        if (itemEl && !itemEl.classList.contains('gk-cart-item-removing')) {
          itemEl.classList.add('gk-cart-item-removing');
        }
        updateCartLine(data, 0);
        return;
      }
      // Minimum quantity guard: never let the minus button drive quantity
      // below 1. Use the trash button to actually remove the line.
      if (minus && data.quantity <= 1) return;
      updateCartLine(data, data.quantity + (plus ? 1 : -1));
    }, true);

    document.addEventListener('change', function (event) {
      var input = closestElement(event.target, '.xo-cart-mini-item input[name="quantity"]');
      if (!input) return;
      var data = getCartLineControlData(input);
      if (!data) return;
      var quantity = parseInt(input.value, 10);
      if (isNaN(quantity) || quantity < 0) quantity = 1;
      event.preventDefault();
      updateCartLine(data, quantity);
    }, true);
  }

  /* ── Announcement ──────────────────────────────────────────── */

  var Ann = {
    init: function () {
      var el = document.getElementById('gk-announcement');
      if (el) el.style.display = '';
    }
  };

  /* ── Confetti ──────────────────────────────────────────────── */

  var Confetti = {
    _active: false, _rafId: null, _particles: [], _canvas: null, _ctx: null,
    _ensureCanvas: function () {
      if (this._canvas) return;
      var container = document.querySelector('xo-cart-mini') ||
                      document.querySelector('.xo-modal-content-style1') ||
                      document.body;
      var isBody = container === document.body;
      if (!isBody) {
        var pos = window.getComputedStyle(container).position;
        if (pos === 'static') container.style.position = 'relative';
      }
      var canvas = document.createElement('canvas');
      canvas.id = 'gk-confetti-canvas';
      canvas.style.cssText = isBody
        ? 'position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:99999;display:none;'
        : 'position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:9999;display:none;';
      container.appendChild(canvas);
      this._canvas = canvas;
      this._ctx = canvas.getContext('2d');
    },
    fire: function () {
      if (this._active) return;
      this._ensureCanvas();
      var canvas = this._canvas;
      var rect = canvas.parentElement ? canvas.parentElement.getBoundingClientRect() : null;
      canvas.width = rect ? rect.width : window.innerWidth;
      canvas.height = rect ? rect.height : window.innerHeight;
      canvas.style.display = 'block';
      this._active = true;
      var colors = ['#62865D', '#f5a623', '#e74c3c', '#3498db', '#9b59b6', '#f1c40f', '#ff6b6b', '#48dbfb'];
      this._particles = [];
      for (var i = 0; i < 140; i++) {
        this._particles.push({
          x: Math.random() * canvas.width, y: Math.random() * canvas.height * 0.4 - canvas.height * 0.4,
          w: Math.random() * 10 + 5, h: Math.random() * 5 + 3,
          color: colors[Math.floor(Math.random() * colors.length)],
          angle: Math.random() * 360, spin: (Math.random() - 0.5) * 7,
          vx: (Math.random() - 0.5) * 5, vy: Math.random() * 4 + 2, alpha: 1
        });
      }
      var self = this;
      function animate() {
        var ctx = self._ctx;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        var alive = false;
        self._particles.forEach(function (p) {
          p.x += p.vx; p.y += p.vy; p.vy += 0.09; p.angle += p.spin;
          if (p.y > canvas.height * 0.65) p.alpha -= 0.025;
          if (p.alpha <= 0) return;
          alive = true;
          ctx.save(); ctx.globalAlpha = p.alpha;
          ctx.translate(p.x, p.y); ctx.rotate(p.angle * Math.PI / 180);
          ctx.fillStyle = p.color; ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
          ctx.restore();
        });
        if (alive && self._active) self._rafId = requestAnimationFrame(animate);
        else { ctx.clearRect(0, 0, canvas.width, canvas.height); canvas.style.display = 'none'; self._active = false; }
      }
      this._rafId = requestAnimationFrame(animate);
      setTimeout(function () {
        if (self._active) self._particles.forEach(function (p) { p.alpha = 0; });
      }, 4000);
    },
    reset: function () {
      if (this._rafId) cancelAnimationFrame(this._rafId);
      this._active = false;
      if (this._canvas) { this._ctx.clearRect(0, 0, this._canvas.width, this._canvas.height); this._canvas.style.display = 'none'; }
    }
  };

  /* ── Tiered Rewards ────────────────────────────────────────── */

  var Rewards = {
    _allUnlocked: false,
    update: function (cartCents) {
      var el = document.getElementById('gk-tiered-rewards');
      if (!el) return;
      var milestoneEls = el.querySelectorAll('[data-amount]');
      if (!milestoneEls.length) return;
      var amounts = [];
      milestoneEls.forEach(function (m) {
        var a = parseInt(m.dataset.amount, 10);
        if (a > 0) amounts.push(a);
      });
      amounts.sort(function (a, b) { return a - b; });
      if (!amounts.length) return;
      var maxAmount = amounts[amounts.length - 1];
      var pct = Math.min(100, (cartCents / maxAmount) * 100);
      var fill = document.getElementById('gk-rewards-fill');
      if (fill) fill.style.width = pct.toFixed(1) + '%';
      milestoneEls.forEach(function (m) {
        var amt = parseInt(m.dataset.amount, 10) || 0;
        m.classList.toggle('is-unlocked', cartCents >= amt);
        var mPct = maxAmount > 0 ? (amt / maxAmount) * 100 : 0;
        m.style.left = mPct.toFixed(1) + '%';
      });
      var msg = document.getElementById('gk-rewards-msg');
      if (!msg) return;
      var showConfetti = el.dataset.confetti !== 'false';
      var completionText = el.dataset.completionText || 'You have unlocked all rewards!';
      var firstPendingAmount = null;
      var firstPendingLabel = 'Reward';
      var firstPreText = '';
      for (var i = 0; i < amounts.length; i++) {
        if (cartCents < amounts[i]) {
          firstPendingAmount = amounts[i];
          var milestone = el.querySelector('[data-amount="' + amounts[i] + '"]');
          if (milestone) {
            var lbl = milestone.querySelector('.gk-milestone__lbl');
            if (lbl) firstPendingLabel = lbl.textContent.trim();
            firstPreText = milestone.dataset.preText || '';
          }
          break;
        }
      }
      if (firstPendingAmount === null) {
        msg.innerHTML = '\uD83C\uDF89 ' + esc(completionText);
        if (!this._allUnlocked) { this._allUnlocked = true; if (showConfetti) Confetti.fire(); }
      } else {
        this._allUnlocked = false;
        Confetti.reset();
        var need = Math.ceil((firstPendingAmount - cartCents) / 100);
        if (firstPreText) msg.innerHTML = esc(firstPreText);
        else msg.innerHTML = 'Add <strong>' + formatMoneyFromRupees(need) + '</strong> more for <strong>' + esc(firstPendingLabel) + '</strong>';
      }
    }
  };

  /* ── Scarcity Timer ────────────────────────────────────────── */

  var Timer = {
    _interval: null,
    _endTime: 0,
    _minutes: 5,
    KEY: 'gk_scarcity_timer_end_v2',
    URGENT_THRESHOLD: 60, // seconds — switch to "urgent" visual state below this

    _format: function (rem) {
      var m = Math.floor(rem / 60);
      var s = rem % 60;
      return (m < 10 ? '0' + m : m) + ':' + (s < 10 ? '0' + s : s);
    },

    _tick: function () {
      var el = document.getElementById('gk-scarcity-countdown');
      if (!el) { Timer._stop(); return; }
      var rem = Math.max(0, Math.round((Timer._endTime - Date.now()) / 1000));
      el.textContent = Timer._format(rem);

      var wrap = document.getElementById('gk-scarcity-timer');
      if (wrap) {
        if (rem === 0) {
          wrap.classList.remove('is-urgent');
          wrap.classList.add('is-expired');
        } else if (rem <= Timer.URGENT_THRESHOLD) {
          wrap.classList.add('is-urgent');
          wrap.classList.remove('is-expired');
        } else {
          wrap.classList.remove('is-urgent', 'is-expired');
        }
      }
      if (rem === 0) Timer._stop();
    },

    _stop: function () {
      if (this._interval) { clearInterval(this._interval); this._interval = null; }
    },

    init: function () {
      var countdown = document.getElementById('gk-scarcity-countdown');
      if (!countdown) return;

      this._minutes = parseInt(countdown.dataset.minutes, 10) || 5;
      var stored = parseInt(sessionStorage.getItem(this.KEY), 10);
      var now = Date.now();
      var maxDuration = this._minutes * 60 * 1000;

      // Reuse the existing endTime if it's still in the future AND not absurdly
      // far ahead (guards against stale values or settings changes shrinking
      // the duration). Otherwise start a fresh timer.
      if (stored && stored > now && (stored - now) <= maxDuration) {
        this._endTime = stored;
      } else {
        this._endTime = now + maxDuration;
        sessionStorage.setItem(this.KEY, String(this._endTime));
      }

      this._stop();
      this._tick();
      // 1s interval is sufficient for second-level accuracy. We compute rem
      // from end-time each tick, so the display stays in sync with wall clock
      // even if the interval fires slightly late (no drift accumulation).
      this._interval = setInterval(this._tick, 1000);
    }
  };

  /* ── Free Gifts ────────────────────────────────────────────── */

  var Gifts = {
    _busy: false,
    _readRules: function () {
      var strip = document.getElementById('gk-free-gift-strip');
      if (!strip) return [];
      var rules = [];
      strip.querySelectorAll('.gk-free-gift__rule').forEach(function (el) {
        var dataEl = el.querySelector('.gk-free-gift__rule-data');
        if (!dataEl) return;
        try {
          var data = JSON.parse(dataEl.textContent || '{}');
          if (!data.giftVariantIds || !data.giftVariantIds.length) return;
          data.el = el;
          data.ruleId = String(data.ruleId || el.dataset.ruleId || '');
          data.threshold = parseInt(data.threshold, 10) || 0;
          data.quantity = parseInt(data.quantity, 10) || 1;
          data.giftVariantIds = (data.giftVariantIds || []).map(String);
          data.excludeVariantIds = (data.excludeVariantIds || []).map(String);
          rules.push(data);
        } catch (e) { /* ignore invalid rule JSON */ }
      });
      return rules;
    },
    _cartContext: function (cartData) {
      var realTotal = 0;
      var paidVariantIds = {};
      (cartData.items || []).forEach(function (item) {
        var props = item.properties || {};
        if (props._is_free_gift === 'true' || props._is_one_tick === 'true') return;
        realTotal += item.final_line_price;
        paidVariantIds[String(item.variant_id)] = true;
      });
      return { realTotal: realTotal, paidVariantIds: paidVariantIds };
    },
    _poolSet: function (rule) {
      var set = {};
      (rule.giftVariantIds || []).forEach(function (id) { set[id] = true; });
      return set;
    },
    _pickGiftVariant: function (rule, paidVariantIds) {
      var exclude = {};
      (rule.excludeVariantIds || []).forEach(function (id) { exclude[id] = true; });
      for (var i = 0; i < rule.giftVariantIds.length; i += 1) {
        var vid = rule.giftVariantIds[i];
        if (exclude[vid]) continue;
        if (paidVariantIds[vid]) continue;
        return vid;
      }
      return null;
    },
    _belongsToRule: function (item, rule, ruleCount) {
      var props = item.properties || {};
      if (props._is_free_gift !== 'true') return false;
      var pool = this._poolSet(rule);
      var ruleId = String(rule.ruleId || '');
      var taggedRule = props._gift_rule_id ? String(props._gift_rule_id) : '';
      var vid = String(item.variant_id);
      if (taggedRule && ruleId && taggedRule === ruleId) return true;
      if (pool[vid]) return true;
      if (!taggedRule && ruleCount === 1) return true;
      return false;
    },
    _ruleGiftLines: function (cartItems, rule, ruleCount) {
      var self = this;
      return (cartItems || []).filter(function (item) {
        return self._belongsToRule(item, rule, ruleCount);
      });
    },
    sync: function (cartData) {
      var rules = this._readRules();
      if (!rules.length) return false;
      if (this._busy) return true;

      var ctx = this._cartContext(cartData);
      var ops = [];
      var self = this;

      rules.forEach(function (rule) {
        var unlocked = ctx.realTotal >= rule.threshold;
        var targetVid = unlocked ? self._pickGiftVariant(rule, ctx.paidVariantIds) : null;
        var ruleLines = self._ruleGiftLines(cartData.items || [], rule, rules.length);
        var title = rule.label || 'Free Gift';

        if (!unlocked || !targetVid) {
          if (!unlocked && rules.length === 1) {
            (cartData.items || []).forEach(function (item) {
              if ((item.properties || {})._is_free_gift === 'true') {
                ops.push({ action: 'remove', key: item.key });
              }
            });
          } else {
            ruleLines.forEach(function (item) {
              ops.push({ action: 'remove', key: item.key });
            });
          }
          return;
        }

        var correctLine = ruleLines.find(function (item) {
          return String(item.variant_id) === String(targetVid);
        });

        ruleLines.forEach(function (item) {
          if (!correctLine || item.key !== correctLine.key) {
            ops.push({ action: 'remove', key: item.key });
          }
        });

        if (!correctLine) {
          ops.push({
            action: 'add',
            variantId: targetVid,
            quantity: rule.quantity || 1,
            title: title,
            ruleId: rule.ruleId
          });
        }
      });

      if (ops.length) {
        this._busy = true;
        this._runOps(ops, function () { self._busy = false; scheduleRefresh(100); });
        return true;
      }

      this._updateGiftUI(cartData.items || [], rules, ctx.realTotal);
      return false;
    },
    _runOps: function (ops, done) {
      if (!ops.length) { done(); return; }
      var op = ops.shift();
      var self = this;
      var next = function () { self._runOps(ops, done); };
      if (op.action === 'add') {
        cartFetch('/cart/add.js', {
          method: 'POST',
          body: JSON.stringify({
            items: [{
              id: parseInt(op.variantId, 10),
              quantity: op.quantity || 1,
              properties: {
                _is_free_gift: 'true',
                _gift_title: op.title || 'Free Gift',
                _gift_rule_id: String(op.ruleId || '')
              }
            }]
          })
        }).then(next).catch(next);
      } else if (op.action === 'remove') {
        cartFetch('/cart/change.js', {
          method: 'POST',
          body: JSON.stringify({ id: op.key, quantity: 0 })
        }).then(next).catch(next);
      } else {
        next();
      }
    },
    _updateGiftUI: function (cartItems, rules, realTotal) {
      rules.forEach(function (rule) {
        var el = rule.el;
        if (!el) return;
        var targetVid = realTotal >= rule.threshold ? this._pickGiftVariant(rule, this._cartContext({ items: cartItems }).paidVariantIds) : null;
        var ruleLines = this._ruleGiftLines(cartItems, rule, rules.length);
        var inCart = targetVid ? ruleLines.find(function (item) {
          return String(item.variant_id) === String(targetVid);
        }) : null;
        var unlocked = realTotal >= rule.threshold && !!targetVid;

        el.classList.toggle('is-unlocked', unlocked);
        var card = el.querySelector('.gk-free-gift__item');
        if (card) card.classList.toggle('is-unlocked', unlocked);

        var statusEl = el.querySelector('.gk-gift__status');
        var badgeEl = el.querySelector('.gk-gift__badge');
        if (statusEl) {
          if (unlocked && inCart) {
            statusEl.textContent = 'Added to cart!';
            statusEl.classList.add('gk-gift__status--added');
          } else if (unlocked) {
            statusEl.textContent = 'Adding\u2026';
            statusEl.classList.remove('gk-gift__status--added');
          } else if (realTotal >= rule.threshold) {
            statusEl.textContent = 'No eligible gift available';
            statusEl.classList.remove('gk-gift__status--added');
          } else {
            var need = Math.ceil((rule.threshold - realTotal) / 100);
            statusEl.textContent = 'Add ' + formatMoneyFromRupees(need) + ' more to unlock';
            statusEl.classList.remove('gk-gift__status--added');
          }
        }
        if (badgeEl) {
          badgeEl.textContent = unlocked && inCart ? '\u2713' : '\uD83D\uDD12';
          badgeEl.classList.toggle('gk-gift__badge--unlocked', unlocked && !!inCart);
        }
      }, this);
    }
  };

  /* ── Gift Images ───────────────────────────────────────────── */

  var GiftImages = {
    _cache: {},
    load: function () {
      document.querySelectorAll('.gk-free-gift__item[data-handle]').forEach(function (item) {
        var wrap = item.querySelector('.gk-gift__img-wrap');
        if (!wrap || wrap.querySelector('img.gk-gift__img')) return;
        var handle = item.dataset.handle;
        if (!handle) return;
        if (GiftImages._cache[handle]) { GiftImages._apply(wrap, GiftImages._cache[handle]); return; }
        fetch('/products/' + handle + '.json').then(function (r) { return r.json(); }).then(function (data) {
          var src = data.product && data.product.image && data.product.image.src;
          if (src) { GiftImages._cache[handle] = src; GiftImages._apply(wrap, src); }
        }).catch(function () {});
      });
    },
    _apply: function (wrap, src) {
      wrap.innerHTML = '<img class="gk-gift__img" src="' + esc(src) + '" alt="" loading="lazy" width="70" height="70">';
    }
  };

  /* ── Cart Loading Overlay ──────────────────────────────────── */

  var CartLoading = {
    _overlay: null,
    _getContainer: function () {
      // Scope overlay to cart line-items only — upsell carousel + footer
      // stay interactive while items refresh (prevents dead buttons/links).
      return document.querySelector('[xo-unique-id="xo-cart-mini-content"]') ||
        document.querySelector('xo-modal[xo-for-cart-mini] .xo-modal-content-style1__content') ||
        document.querySelector('xo-modal[xo-name="cart"] .xo-modal-content-style1__content');
    },
    _getOverlay: function () {
      if (this._overlay && this._overlay.isConnected) return this._overlay;
      var container = this._getContainer();
      if (!container) return null;
      var pos = window.getComputedStyle(container).position;
      if (pos === 'static') container.style.position = 'relative';
      var div = document.createElement('div');
      div.className = 'gk-cart-loading-overlay';
      div.innerHTML = '<div class="gk-cart-loading-spinner"></div>';
      container.appendChild(div);
      this._overlay = div;
      return div;
    },
    show: function () { var el = this._getOverlay(); if (el) el.classList.add('is-active'); },
    hide: function () { if (this._overlay) this._overlay.classList.remove('is-active'); }
  };

  /* ── Cart Sync (loading state) ─────────────────────────────── */

  var CartSync = {
    _active: false, _hideTimer: null, _safetyTimer: null, _minVisibleUntil: 0,
    begin: function () {
      this._active = true;
      this._minVisibleUntil = Math.max(this._minVisibleUntil, Date.now() + 250);
      clearTimeout(this._hideTimer);
      clearTimeout(this._safetyTimer);
      document.documentElement.classList.add('gk-cart-syncing');
      CartLoading.show();
      this._safetyTimer = setTimeout(function () {
        if (CartSync._active) CartSync.finish();
      }, 4000);
    },
    finish: function () {
      if (!this._active) return;
      this._active = false;
      clearTimeout(this._safetyTimer);
      var wait = Math.max(0, this._minVisibleUntil - Date.now());
      clearTimeout(this._hideTimer);
      this._hideTimer = setTimeout(function () {
        if (!CartSync._active) {
          document.documentElement.classList.remove('gk-cart-syncing');
          CartLoading.hide();
        }
      }, wait);
    },
    isActive: function () { return this._active; }
  };

  /* ── Free Gift Cart UI ─────────────────────────────────────── */

  var FreeGiftCartUI = {
    apply: function (cartItems) {
      if (!cartItems || !cartItems.length) return;
      cartItems.forEach(function (item) {
        if ((item.properties || {})._is_free_gift !== 'true') return;
        var lineKey = item.key;
        var els = document.querySelectorAll('.xo-cart-mini-item[data-line-key="' + lineKey + '"]');
        if (!els.length) return;
        els.forEach(function (el) {
          if (el.dataset.gkGiftMarked) return;
          el.dataset.gkGiftMarked = '1';
          el.classList.add('gk-is-free-item');
          var priceEl = el.querySelector('.xo-cart-mini-item__price');
          if (priceEl && !priceEl.querySelector('.xo-cart-mini-item__free-price')) {
            priceEl.innerHTML = '<span class="gk-free-item-badge">FREE</span>';
          }
          el.querySelectorAll('.xo-cart-mini-item__quatity-remove button, .xo-cart-mini-item__quatity-remove input').forEach(function (btn) {
            btn.disabled = true;
            if (btn.tagName === 'INPUT') btn.readOnly = true;
          });
          var removeEl = el.querySelector('.xo-cart-mini-item__remove');
          if (removeEl) removeEl.style.display = 'none';
        });
      });
    },
    reset: function () {
      document.querySelectorAll('.xo-cart-mini-item.gk-is-free-item').forEach(function (el) {
        delete el.dataset.gkGiftMarked;
        el.classList.remove('gk-is-free-item');
        el.style.removeProperty('display');
      });
    }
  };

  /* ── Savings Bar ───────────────────────────────────────────── */

  var Savings = {
    update: function (cartData) {
      var bar = document.getElementById('gk-savings-bar');
      if (!bar) return;
      var total = 0;
      (cartData.items || []).forEach(function (item) {
        if (item.original_line_price > item.final_line_price) total += item.original_line_price - item.final_line_price;
      });
      (cartData.cart_level_discount_applications || []).forEach(function (d) { total += d.total_allocated_amount || 0; });
      if (total > 0) {
        var amtEl = bar.querySelector('.gk-savings__amount');
        if (amtEl) amtEl.textContent = ' ' + formatMoney(total);
        bar.style.display = '';
      } else {
        bar.style.display = 'none';
      }
    }
  };

  /* ── One-Tick Checkbox ─────────────────────────────────────── */

  var OneTick = {
    _busy: false,
    init: function () {
      var el = document.getElementById('gk-one-tick');
      var chk = document.getElementById('gk-one-tick-check');
      if (!el || !chk || chk._gkBound) return;
      var vid = el.dataset.variantId;
      if (!vid) return;
      chk._gkBound = true;
      chk.addEventListener('change', function () {
        if (OneTick._busy) { chk.checked = !chk.checked; return; }
        OneTick._busy = true;
        if (chk.checked) {
          cartFetch('/cart/add.js', { method: 'POST', body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1, properties: { _is_one_tick: 'true' } }] }) })
            .then(function () { OneTick._busy = false; scheduleRefresh(100); })
            .catch(function () { OneTick._busy = false; chk.checked = false; });
        } else {
          cartFetch('/cart.js').then(function (cart) {
            var found = (cart.items || []).find(function (item) { return String(item.variant_id) === vid && (item.properties || {})._is_one_tick === 'true'; });
            if (!found) { OneTick._busy = false; return; }
            return cartFetch('/cart/change.js', { method: 'POST', body: JSON.stringify({ id: found.key, quantity: 0 }) });
          }).then(function () { OneTick._busy = false; scheduleRefresh(100); })
            .catch(function () { OneTick._busy = false; chk.checked = true; });
        }
      });
    }
  };

  /* ── Upsell Carousel ───────────────────────────────────────── */

  // NOTE: The actual upsell carousel population is owned by
  // cart-drawer-upsell-fix.js (fillUpsell + renderUpsell) which uses
  // /collections/all/products.json and pickProducts(). We keep this
  // stub so existing call sites (init(), onCartChange()) don't break,
  // but it does nothing — preventing the duplicate /recommendations
  // fetch that throws 422 on undefined pid and races with the
  // upsell-fix.js renderer on the same #gk-upsell-carousel node.
  var Upsell = {
    _loaded: false, _loading: false, _lastProductId: null,
    sync: function () { /* no-op: handled by cart-drawer-upsell-fix.js */ },
    load: function () { /* no-op: handled by cart-drawer-upsell-fix.js */ },
    _legacyLoad: function (pid) {
      if (!pid) return; // guard: prevents /recommendations?product_id=undefined → 422
      var upsellEl = document.getElementById('gk-cart-upsell');
      if (!upsellEl || this._loaded || this._loading) return;
      var carouselEl = document.getElementById('gk-upsell-carousel');
      if (!carouselEl) return;
      this._loading = true;
      var self = this;
      var limit = parseInt(upsellEl.dataset.limit, 10) || 6;
      cartFetch('/recommendations/products.json?product_id=' + pid + '&limit=' + limit + '&intent=related')
        .then(function (data) {
          if (!data || !data.products || !data.products.length) {
            var el = document.getElementById('gk-cart-upsell');
            if (el) el.style.display = 'none';
            self._loading = false;
            return;
          }
          self._loaded = true;
          self._loading = false;
          var freshCarousel = document.getElementById('gk-upsell-carousel');
          var freshLoading = document.getElementById('gk-upsell-loading');
          if (!freshCarousel) return;
          if (freshLoading) freshLoading.style.display = 'none';
          freshCarousel.innerHTML = data.products.map(function (p) {
            var v = p.variants[0];
            var salePrice = v.price, comparePrice = v.compare_at_price;
            var hasDiscount = comparePrice && comparePrice > salePrice;
            var discountPct = hasDiscount ? Math.round((1 - salePrice / comparePrice) * 100) : 0;
            var imgSrc = p.featured_image && (p.featured_image.src || p.featured_image) || '';
            var imgTag = imgSrc
              ? '<img class="gk-upsell__img" src="' + esc(imgSrc) + '" alt="' + esc(p.title) + '" loading="lazy" width="110" height="110">'
              : '<div class="gk-upsell__img gk-upsell__img--placeholder"></div>';
            var badgeHtml = hasDiscount ? '<div class="gk-upsell__discount-badge">' + discountPct + '% off</div>' : '';
            var priceHtml = hasDiscount
              ? '<s class="gk-upsell__compare">' + formatMoney(comparePrice) + '</s><span class="gk-upsell__price">' + formatMoney(salePrice) + '</span>'
              : '<span class="gk-upsell__price">' + formatMoney(salePrice) + '</span>';
            return '<div class="gk-upsell__item" data-variant-id="' + v.id + '">' +
              '<div class="gk-upsell__img-wrap">' + imgTag + badgeHtml + '</div>' +
              '<div class="gk-upsell__body"><div class="gk-upsell__title">' + esc(p.title) + '</div>' +
              '<div class="gk-upsell__price-row">' + priceHtml + '</div>' +
              '<button class="gk-upsell__add" type="button">+ Add</button></div></div>';
          }).join('');
          freshCarousel.querySelectorAll('.gk-upsell__add').forEach(function (btn) {
            btn.addEventListener('click', function () {
              var item = btn.closest('.gk-upsell__item');
              var vid = item && item.dataset.variantId;
              if (!vid || btn.disabled) return;
              btn.disabled = true; btn.classList.add('is-loading'); btn.textContent = '\u2026';
              cartFetch('/cart/add.js', { method: 'POST', body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }] }) })
                .then(function () { btn.classList.remove('is-loading'); btn.textContent = '\u2713 Added'; scheduleRefresh(100); })
                .catch(function () { btn.disabled = false; btn.classList.remove('is-loading'); btn.textContent = '+ Add'; });
            });
          });
        })
        .catch(function () {
          self._loading = false;
          var el = document.getElementById('gk-cart-upsell');
          if (el) el.style.display = 'none';
        });
    },
    reset: function () {
      this._loaded = false; this._loading = false;
      var c = document.getElementById('gk-upsell-carousel'); if (c) c.innerHTML = '';
      var l = document.getElementById('gk-upsell-loading'); if (l) l.style.display = '';
    }
  };

  /* ── Checkout Styling ──────────────────────────────────────── */

  var Checkout = {
    _radiusPx: function (value, fallback) {
      if (value == null || value === '') return fallback + 'px';
      var parsed = parseInt(value, 10);
      return isNaN(parsed) ? fallback + 'px' : parsed + 'px';
    },
    apply: function () {
      var cfg = (window.MAGIC_CONFIG && window.MAGIC_CONFIG.checkout) || CFG.checkout || {};
      var vcCfg = (window.MAGIC_CONFIG && window.MAGIC_CONFIG.viewcart) || CFG.viewcart || {};
      var footerCfg = (window.MAGIC_CONFIG && window.MAGIC_CONFIG.footer) || CFG.footer || {};

      document.querySelectorAll('.gk-checkout-btn').forEach(function (btn) {
        if (cfg.bg) btn.style.setProperty('background', cfg.bg, 'important');
        if (cfg.color) btn.style.setProperty('color', cfg.color, 'important');
        if (cfg.label) btn.textContent = cfg.label;
        btn.style.setProperty('border-radius', Checkout._radiusPx(cfg.borderRadius, 4), 'important');
      });

      var viewCartHidden = vcCfg.hidden === true || vcCfg.enabled === false;
      document.querySelectorAll('.cart-mini-item__viewcart').forEach(function (wrap) { wrap.style.display = viewCartHidden ? 'none' : ''; });
      document.querySelectorAll('.gk-viewcart-btn').forEach(function (vcBtn) {
        if (viewCartHidden) { vcBtn.style.display = 'none'; return; }
        vcBtn.style.removeProperty('display');
        if (vcCfg.bg) vcBtn.style.setProperty('background', vcCfg.bg, 'important');
        if (vcCfg.color) { vcBtn.style.setProperty('color', vcCfg.color, 'important'); vcBtn.style.setProperty('border-color', vcCfg.color, 'important'); }
        if (vcCfg.label) vcBtn.textContent = vcCfg.label;
        vcBtn.style.setProperty('border-radius', Checkout._radiusPx(vcCfg.borderRadius, 4), 'important');
      });

      var footer = document.querySelector('.xo-cart-mini-footer');
      if (footer) {
        var msg = footer.querySelector('.gk-cart-footer-msg');
        if (!footerCfg.enabled) { if (msg) msg.remove(); return; }
        if (!msg) { msg = document.createElement('p'); msg.className = 'gk-cart-footer-msg'; footer.appendChild(msg); }
        msg.textContent = footerCfg.text || 'Order will be Delivered within 7 Working days!';
        msg.style.color = footerCfg.color || '#0051F7';
      }
    }
  };

  /* ── Cart Title ────────────────────────────────────────────── */

  function updateCartTitle(itemCount) {
    var titleEl = document.querySelector('xo-cart-mini .xo-modal-content-style1__title');
    if (!titleEl) return;
    titleEl.textContent = itemCount === 1 ? 'Your Cart (1 item)' : 'Your Cart (' + itemCount + ' items)';
  }

  /* ── Cart Change Handler ───────────────────────────────────── */

  function onCartChange(cartData) {
    var cart = cartData && cartData.data ? cartData.data : cartData;
    if (!cart) return false;

    var hasLineItems = Array.isArray(cart.items);
    var itemCount = typeof cart.item_count === 'number' ? cart.item_count :
                    typeof cart.size === 'number' ? cart.size : (cart.items || []).length;
    var isEmpty = itemCount === 0;

    updateCartTitle(cart.item_count || itemCount);

    var topSlot = document.getElementById('gk-top-blocks-slot');
    var botSlot = document.getElementById('gk-bottom-blocks-slot');
    if (topSlot) topSlot.style.display = isEmpty ? 'none' : '';
    if (botSlot) botSlot.style.display = isEmpty ? 'none' : '';

    if (!hasLineItems && itemCount > 0) { scheduleRefresh(0); return true; }
    if (isEmpty) return false;

    Rewards.update(Gifts._cartContext(cart).realTotal);
    var giftsPending = Gifts.sync(cart) === true;
    Savings.update(cart);
    setTimeout(function () { FreeGiftCartUI.apply(cart.items); }, 100);
    Upsell.sync(cart);
    return giftsPending;
  }

  /* ── Init ──────────────────────────────────────────────────── */

  function init() {
    setupMagicBlocks(function () {
      Ann.init();
      Timer.init();
      OneTick.init();
      Upsell.load();
      Checkout.apply();
      bindCartControlFallbacks();
      dedupeCartItemsDisplay();
      observeCartItemsForDedupe();

      cartFetch('/cart.js').then(function (cart) {
        onCartChange(cart);
        GiftImages.load();
      });

      if (typeof cartSubscribe === 'function') {
        cartSubscribe(function (cartData) { if (cartData) onCartChange(cartData); });
      }

      var cartEventNames = [
        'cart:change', 'cart:updated', 'cart:add',
        'xo:cart:updated', 'theme:cart:updated',
        'on:cart:toggle', 'shopify:cart:updated', 'ajax-cart:render'
      ];
      cartEventNames.forEach(function (name) {
        document.addEventListener(name, function () { scheduleRefresh(400); });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.GKCartDrawerPro = {
    refresh: function (done) { themeCartRefresh(done); },
    formatMoney: formatMoney,
    scheduleRefresh: scheduleRefresh,
    version: '2.0.0'
  };
})();
